import { render, staticRenderFns } from "./access_shipments_records.vue?vue&type=template&id=755b8e88&scoped=true"
import script from "./access_shipments_records.vue?vue&type=script&lang=js"
export * from "./access_shipments_records.vue?vue&type=script&lang=js"
import style0 from "./access_shipments_records.vue?vue&type=style&index=0&id=755b8e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755b8e88",
  null
  
)

export default component.exports